import Loadable from "@loadable/component"

const Icon = Loadable(() => import("./Loadable/LoadableIcon"))
const Loader = Loadable(() => import("./Loadable/LoadableLoader"))
const ExampleIcons = Loadable(() => import("./Loadable/LoadableExampleIcons"))

export default Icon

export { Loader, ExampleIcons }
